/**
 *
 * @param {string} cookieName
 * @returns {string|undefined} cookie
 */
const readCookie = (cookieName) => {
    // This cookie getting function was taken from the Mozilla docs
    // https://developer.mozilla.org/en-US/docs/Web/API/Document/cookie
    const cookie = document.cookie
        .split("; ")
        .find((row) => row.startsWith(cookieName))
        ?.split("=")[1];
    return cookie;
};

export default readCookie;
